import { CountryTag } from "@/components/country-tag";
import { Flag } from "@/components/flag";
import { Tooltip } from "@/components/tooltip";
import { toIsoCode } from "@/app/(app)/_lib/iso-countries";
import { collapseKnownCollections, dataSourceLabel } from "@/components/watchlists";

const TABLE_CHIP_CLASS =
  "inline-flex items-center rounded-[4px] bg-grey-100 px-2 py-1 text-tiny font-medium text-grey-900";

export function SourceChips({ sources }: { sources: string[] }) {
  const collapsed = collapseKnownCollections(sources);
  if (collapsed.length === 0) return <span className="text-grey-500">—</span>;

  if (collapsed.length === 1) {
    const label = dataSourceLabel(collapsed[0]);
    return (
      <span title={label} className={`max-w-full ${TABLE_CHIP_CLASS}`}>
        <span className="min-w-0 truncate">{label}</span>
      </span>
    );
  }

  return (
    <Tooltip
      align="start"
      description={
        <span className="flex flex-row flex-wrap gap-x-2 gap-y-1">
          {collapsed.map((source) => (
            <span key={source} className={TABLE_CHIP_CLASS}>
              {dataSourceLabel(source)}
            </span>
          ))}
        </span>
      }
    >
      <span className={TABLE_CHIP_CLASS}>{collapsed.length}</span>
    </Tooltip>
  );
}

export function CountryChips({ countries }: { countries: string[] }) {
  if (countries.length === 0) return <span className="text-grey-500">—</span>;
  if (countries.length === 1) return <CountryTag iso={countries[0]} />;

  return (
    <Tooltip
      align="start"
      description={
        <span className="flex flex-row flex-wrap gap-x-2 gap-y-1">
          {countries.map((raw) => {
            const code = toIsoCode(raw) || raw;
            return (
              <span key={raw} className="inline-flex items-center gap-1.5">
                <Flag iso={code} size={14} />
                <span>{code}</span>
              </span>
            );
          })}
        </span>
      }
    >
      <span className={TABLE_CHIP_CLASS}>{countries.length}</span>
    </Tooltip>
  );
}
